import { render, staticRenderFns } from "./yk.vue?vue&type=template&id=4885af4b&scoped=true"
import script from "./yk.vue?vue&type=script&lang=js"
export * from "./yk.vue?vue&type=script&lang=js"
import style0 from "./yk.vue?vue&type=style&index=0&id=4885af4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885af4b",
  null
  
)

export default component.exports